import { render, staticRenderFns } from "./OrderListMobile.vue?vue&type=template&id=a7ce3fb2&scoped=true&"
import script from "./OrderListMobile.vue?vue&type=script&lang=js&"
export * from "./OrderListMobile.vue?vue&type=script&lang=js&"
import style0 from "./OrderListMobile.vue?vue&type=style&index=0&id=a7ce3fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ce3fb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VPagination,VRow})
